export default __webpack_public_path__ + "static/media/LogoWhite.bb492413.png";